module.exports = __webpack_public_path__ + "img/blindbox.f67c4917.png";